import { getValidationReasonLabel, getValidationState } from '@/lib/validation'
import type { Customer } from '@/api/types'

const NEEDS_REVIEW_LABEL = 'Behöver kontroll'

const lineBaseClass = 'mt-1 block text-xs'

export function CustomerValidationLine({ customer }: { customer: Customer }): React.ReactElement | null {
  const state = getValidationState(customer)

  if (state === 'needs_review') {
    return (
      <span className={`${lineBaseClass} text-amber-700`}>
        {NEEDS_REVIEW_LABEL} — {getValidationReasonLabel(customer.validation_reason)}
      </span>
    )
  }

  return null
}
